/* eslint-disable import/prefer-default-export */
import * as Ladda from 'ladda';


export class LoginForm {
    constructor(options) {
        const loginForm = $('#login_form');
        const loginButton = $('#login_button');
        const errorsPlaceholder = $('#messages');

        loginForm.on('keyup', ':input', (e) => {
            if (e.keyCode === 13) {
                loginButton.trigger('click');
            }
        });

        loginButton.on('click', (e) => {
            e.preventDefault();

            const l = Ladda.create(loginButton[0]);
            l.start();

            const postData = loginForm.find(':input').serialize();
            $.post(`${options.controller_url}do-login`, postData, (data) => {
                if (data) {
                    if (data.msg) {
                        if (data.msg.code === 0) {
                            errorsPlaceholder.removeClass('invalid-feedback');
                            errorsPlaceholder.addClass('valid-feedback');
                        } else {
                            errorsPlaceholder.removeClass('valid-feedback');
                            errorsPlaceholder.addClass('invalid-feedback');
                            loginForm.find(':input[type!=hidden]:first').focus().select();
                        }
                        errorsPlaceholder.removeClass('hidden').html(data.msg.text);
                        return;
                    }

                    if (data.url) {
                        window.location.href = data.url;
                    }
                }
            })
                .always(() => {
                    l.stop();
                });
        });
    }
}
